import { Icon, MessageBar, MessageBarType, Panel, PanelType, Stack } from "office-ui-fabric-react";
import { useEffect, useState } from "react";
import { Redirect, useHistory } from "react-router";
import { getSite, loadLocations } from "../../../api/siteslocations";
import { ILocation, ISite } from "../../../types/SiteLocation.types";

export interface IBookingLocationPanelProps {
    onDismiss: () => void;
    startDateStr: string;
    endDateStr: string;
    siteId: number;
}

export const BookingLocationPanel = (props: IBookingLocationPanelProps) => {
    const {startDateStr, endDateStr, siteId, onDismiss} = props;
    const history = useHistory();

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ loading, setLoading ] = useState(true);
    const [ locations, setLocations ] = useState<ILocation[]|undefined>();
    const [ siteNotes, setSiteNotes ] = useState<string>();
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const [ error, setError ] = useState<string>();

    const _load = async () => {
        setLoading(true);
        await _loadSiteInfo();
        await _loadLocations();
        setLoading(false);
    };

    const _loadSiteInfo = async () => {
        const siteResponse = await getSite(props.siteId);
        if (siteResponse.ok) {
            const site = await siteResponse.json() as ISite;
            if (site && site.Notes) setSiteNotes(site.Notes);
        }
    };

    const _loadLocations = async () => {
        setLoading(true);
        const locationsResponse = await loadLocations(siteId, true);
        if (locationsResponse.ok) {
            setLocations(await locationsResponse.json());
        } else {
            setError("Unable to load locations: " + locationsResponse.statusText);
        }
        setLoading(false);
    };

    useEffect(() => {
        _load();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (locations && locations.length === 1) {
        return (
            <Redirect to={`/menu/book/desk/${startDateStr}/${endDateStr}/${siteId}/${locations[0].Id}`} />
        );
    }

    return (
        <Panel type={PanelType.smallFixedFar} isOpen={true} headerText="Choose a site location" onDismiss={onDismiss}>
            { Boolean(siteNotes) === true && (
                <MessageBar styles={{root: { marginTop: 20}}} messageBarType={MessageBarType.info}>{siteNotes}</MessageBar>
            )}
            <Stack horizontalAlign="center" style={{marginTop:20}}>    
                { locations !== undefined && locations.map((location) => (
                    <button style={{backgroundColor: "#005EB8", color: "white", borderRadius: 7, marginBottom: 10}} onClick={() => {
                        history.push(`/menu/book/desk/${startDateStr}/${endDateStr}/${siteId}/${location.Id}`);
                    }}>
                        <Stack horizontal horizontalAlign="space-around" verticalAlign="center" style={{width: 150, height: 100}}>
                            <Icon iconName="CityNext" style={{fontSize: "1.2rem"}} />
                            <div>{location.Title}</div>
                        </Stack>
                    </button>
                ))}
            </Stack>
        </Panel>
    );
}